import { FC, useEffect, useState } from 'react';
import { imagesService } from '../../../services/api/images';

export const SecureImg: FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  const src = props.src || null;
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  useEffect(() => {
    if (src) {
      const getImage = async () => {
        const blob = await imagesService.get(src);
        setBlobUrl(blob ? URL.createObjectURL(blob) : null);
      };
      getImage();
    }
  }, [src]);

  const onLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    URL.revokeObjectURL(blobUrl || '');
    if (props.onLoad) {
      props.onLoad(event);
    }
  };

  if (!blobUrl) {
    return null;
  }

  return <img {...props} src={blobUrl} alt={props.alt} onLoad={onLoad}></img>;
};
